import { render, staticRenderFns } from "./SourceList.vue?vue&type=template&id=3d0c3bf4&scoped=true&"
import script from "./SourceList.vue?vue&type=script&lang=js&"
export * from "./SourceList.vue?vue&type=script&lang=js&"
import style0 from "./SourceList.vue?vue&type=style&index=0&id=3d0c3bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c3bf4",
  null
  
)

export default component.exports